import "./style.less";
export default function UpdateBpNoteForm() {
    return {
        restrict: "E",
        scope: {
            bp: "=",
        },
        template: require("./template.html"),

        controller: function ($scope, Bookings) {
            $scope.model = angular.copy($scope.bp.note);
            $scope.updated = false;
            $scope.saveBpNote = ($event, bp) => {
                $event.stopPropagation(); // TO DO ::: LOW ::: collapses acccordian unintentionally
                $event.preventDefault();

                $scope.updated = false;

                bp.note = $scope.model;

                delete bp.booking._status;
                delete bp._isOpen;

                Bookings.updateBookingPeriod(bp).then(() => {
                    $scope.updated = true;
                });
            };
        },
    };
}
